function MobileStatusBar() {
  return (
    <div aria-hidden="true" className="photo-select-status">
      <span>10:20</span>
      <span className="photo-select-status-icons">
        <i className="photo-select-signal" />
        <i className="photo-select-wifi" />
        <i className="photo-select-battery" />
      </span>
    </div>
  );
}

export { MobileStatusBar };
